'use client';

import { BASE_FILE_URL } from '@/common/constants';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import DatePickerModal from '../DatePickerModal';
import { formatDateVN } from '@/common/ultils';

function RelatedArticles({ relatedPosts, websiteCode }) {
  const t = useTranslations('');
  const router = useRouter();
  const [selectedDate, setSelectedDate] = useState(null);

  const handleSubmit = () => {
    if (selectedDate) {
      router.push(`/tim-kiem-tin-tuc?date=${formatDateVN(selectedDate)}`);
    }
  };

  const renderRelatedPost = () => {
    return relatedPosts.map((item) => {
      const hasImage = !!item?.imgaeUrls;
      const imageUrl = hasImage ? `${BASE_FILE_URL}/${item.imgaeUrls}` : `/img-default.png`;

      return (
        <Link
          href={websiteCode ? `/sub/${websiteCode}/${item?.menu?.slug}/${item?.slug}` : `/${item?.menu?.slug}/${item?.slug}`}
          key={item?.id}
          className="block bg-white p-3 rounded shadow">
          <div className="w-full h-[200px] overflow-hidden rounded">
            <img src={imageUrl} alt="ảnh" className={`w-full h-full object-contain ${!hasImage && 'object-contain p-6 bg-gray-100'}`} />
          </div>

          <div className="h-[70px] overflow-hidden mt-2">
            <h4 className="font-semibold text-base line-clamp-2">{item.title}</h4>
            <div className="text-gray-500 text-xs mb-3 flex justify-between italic mt-2">
              <div className="mr-7">
                <ClockCircleOutlined className="mr-1" />
                {!!(item?.postedDate ?? item?.date) ? formatDateVN(item?.postedDate ?? item?.date) : ''}
              </div>
              <div>
                {t('articleDetail.source')}: {item?.source?.name ?? item?.createdBy?.name ?? 'admin'}
              </div>
            </div>
          </div>
        </Link>
      );
    });
  };

  return (
    <>
      {relatedPosts.length > 0 && (
        <>
          {/* Bộ lọc theo ngày */}
          <div className="flex">
            <DatePickerModal value={selectedDate} onChange={(d) => setSelectedDate(d)} />

            <button onClick={handleSubmit} className="bg-blue-600 text-white px-4 ml-2 py-1 rounded-lg hover:bg-blue-700">
              {t('home.find')}
            </button>
          </div>

          {/* Tiêu đề */}
          <h5 className="font-semibold text-2xl mt-4">{t('articleDetail.relatedNews')}</h5>

          {/* Danh sách bài viết */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5 mt-2">{renderRelatedPost()}</div>
        </>
      )}
    </>
  );
}

export default RelatedArticles;
